import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unauth-terms-and-conditions',
  templateUrl: './unauth-terms-and-conditions.component.html',
  styleUrls: ['./unauth-terms-and-conditions.component.scss']
})
export class UnauthTermsAndConditionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
